import { render, staticRenderFns } from "./SezarAttribute.vue?vue&type=template&id=543eb903&scoped=true"
import script from "./SezarAttribute.vue?vue&type=script&lang=js"
export * from "./SezarAttribute.vue?vue&type=script&lang=js"
import style0 from "./SezarAttribute.vue?vue&type=style&index=0&id=543eb903&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543eb903",
  null
  
)

export default component.exports